/** Created by azhou on 2019/3/18.*/
<template>
  <div>
    <div class="wechat-QRcode">
      <!-- <img :src="wechatInfo.avatar" alt="" v-if="!nickName"> -->
      <img :src="codeImg" alt="" v-if="!nickName">
      <p class="text-link" @click="getQRCode" v-show="!nickName">
        <i class="iconfont icon-shuaxin mr-1 h6"></i>刷新
      </p>
    </div>
    <div class="mt-3 mb-3">
      <i class="iconfont text-success"  v-if="nickName">
        <span v-if="!wechatInfo.nickName">已关注</span>
      </i>
      <span class="h3 mr-2">{{wechatInfo.nickName}}</span>
      <span class="h3" v-if="nickName">[<a href="javascript:;" @click="unBindQRCode">解绑</a>]</span>
    </div>
    <div class="text-danger h5">(关注订单雨，您可以接收到订单消息通知)</div>
    <div class="border-top pt-3 d-start-start" v-if="!nickName">
      <i class="iconfont text-danger">&#xe653;</i>
      <div class="text-left ml-2" >
        <p>1、该二维码涉及用户信息，请千万不要泄露</p>
        <p class="mt-2 mb-2">2、二维码有效时间1分钟，如过期请点击刷新</p>
        <p>3、交易信息只向主账号绑定的微信推送</p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'WechatSet',
    computed: {
      ...mapState(['wechatInfo','userLoginMessage']),
    },
    
    data() {
      return {
        codeImg:'',
        nickName:true,
      }
    },
      watch: {
      wechatInfo (newVal) {
        if (newVal.openid) {                                                      //微信绑定成功
          this.$message.success('微信绑定成功！')
          this.updateInfo({wechat_openid:newVal.openid});
          this.nickName=true;
          // this.getQRCode();
        }
      }
    },
    async created() {
      //获取微信绑定信息时，没有绑定会返回绑定的二维码
      if(this.userLoginMessage.wechat_openid==""||this.userLoginMessage.uid==this.userLoginMessage.wechat_openid){
        this.codeImg = await this.getWechatQRCode();
        this.nickName=false;
      }else{
        this.nickName=true;
      }
      // this.codeImg = await this.getUserWechat();
      // if(!this.codeImg){
      //   this.codeImg = await this.getWechatQRCode();
      // }
    },
    methods:{
      ...mapActions(['getUserWechat','getWechatQRCode','unBindUserWechat','updateInfo']),
      async unBindQRCode() {
        await this.$confirm('解绑后不再接收订单消息提醒？','提示').then(async()=>{
          //解绑后重新返回绑定二维码
          this.codeImg = await this.unBindUserWechat();
          this.updateInfo({wechat_openid:this.userLoginMessage.uid});
          this.nickName=false;
        },()=>{})        
      },
      async getQRCode() {
        this.codeImg = await this.getWechatQRCode();
      }
    }
  }
</script>
<style lang="scss" scoped>
  .wechat-QRcode {
    margin: auto;
    img{
      border: 1px solid #ddd;
      width: 200px;
      height: 200px;
    }
  }
</style>
